module.exports = __webpack_public_path__ + "img/FISH.bb29e887.png";